import React, { Component } from "react";
import { API_FILE_URL } from "../../api/config";
import { fileUrl } from "../../i18n/i18n";
import { clean } from "../../utils/strings";

class AboutV4 extends Component {
  render() {
    const publicUrl = process.env.PUBLIC_URL + "/";
    const aboutData = this.props.aboutData || {};
    const lang = this.props.lang || "tr";

    const t = aboutData?.translations?.[lang] || {};
    const coverPath = clean(aboutData.cover);
    const cover = fileUrl(API_FILE_URL, coverPath);

    // Dil bazlı note gösterim bayrağı
    const showNote =
      lang === "tr" ? !!aboutData?.showTrNote : !!aboutData?.showEnNote;

    return (
      <div className="ltn__about-us-area pt-120--- pb-50 mt--30 go-top">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="ltn__section-title-2--- mb-20">
                <h6 className="section-subtitle section-subtitle-2 ltn__secondary-color">
                  {t.title || "Hakkımızda"}
                </h6>
                <div dangerouslySetInnerHTML={{ __html: t.content || "" }} />
              </div>
            </div>
            <div className="col-lg-6 align-self-center">
              <div className="about-us-img-wrap about-img-left">
                <img
                  src={cover || publicUrl + "assets/img/others/1.jpg"}
                  alt="Safkar About Us"
                />
              </div>
            </div>
            <div className="col-lg-6 align-self-center">
              <div className="about-us-info-wrap" style={{ fontSize: 14 }}>
                {/* NOTE alanı: sadece ilgili dilin show*Note bayrağı true ise ve note varsa göster */}
                {showNote && t.note && (
                  <div className="ltn__callout bg-overlay-theme-05 mt-30">
                    <div dangerouslySetInnerHTML={{ __html: t.note }} />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default AboutV4;
